import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-6" }
const _hoisted_4 = { class: "bg-gradient-to-r from-[#225f7a] to-[#2c7a96] p-6 text-white" }
const _hoisted_5 = { class: "flex items-start justify-between mb-4" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_8 = { class: "text-2xl font-bold" }
const _hoisted_9 = { class: "text-blue-100 text-sm leading-relaxed" }
const _hoisted_10 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4 mt-4" }
const _hoisted_11 = { class: "bg-white/10 backdrop-blur-sm rounded-lg p-3" }
const _hoisted_12 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_13 = { class: "text-xl font-bold" }
const _hoisted_14 = { class: "bg-white/10 backdrop-blur-sm rounded-lg p-3" }
const _hoisted_15 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_16 = { class: "text-xl font-bold" }
const _hoisted_17 = { class: "bg-white/10 backdrop-blur-sm rounded-lg p-3" }
const _hoisted_18 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_19 = { class: "text-xl font-bold" }
const _hoisted_20 = { class: "bg-white/10 backdrop-blur-sm rounded-lg p-3" }
const _hoisted_21 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_22 = { class: "text-xs font-mono" }
const _hoisted_23 = { class: "p-6" }
const _hoisted_24 = { class: "grid md:grid-cols-2 gap-6" }
const _hoisted_25 = { class: "space-y-6" }
const _hoisted_26 = { class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2" }
const _hoisted_27 = { class: "flex flex-wrap gap-2" }
const _hoisted_28 = { class: "font-bold" }
const _hoisted_29 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_30 = { class: "bg-slate-50 rounded-lg p-4 border border-slate-200" }
const _hoisted_31 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_32 = { class: "text-sm font-bold text-slate-800" }
const _hoisted_33 = { class: "text-xs text-slate-600" }
const _hoisted_34 = { class: "bg-slate-50 rounded-lg p-4 border border-slate-200" }
const _hoisted_35 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_36 = { class: "text-sm font-bold text-slate-800" }
const _hoisted_37 = { class: "text-xs text-slate-600" }
const _hoisted_38 = { class: "bg-amber-50 rounded-lg p-4 border border-amber-200" }
const _hoisted_39 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_40 = { class: "text-sm font-bold text-amber-900" }
const _hoisted_41 = { class: "text-xs text-amber-700" }
const _hoisted_42 = { class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2" }
const _hoisted_43 = { class: "ml-auto bg-slate-100 text-slate-700 px-2 py-1 rounded text-xs" }
const _hoisted_44 = { class: "max-h-80 overflow-y-auto space-y-2 pr-2 custom-scrollbar" }
const _hoisted_45 = { class: "flex items-start gap-3" }
const _hoisted_46 = { class: "bg-[#225f7a] text-white px-2 py-1 rounded text-xs font-bold min-w-[3rem] text-center" }
const _hoisted_47 = { class: "text-sm text-slate-700 flex-1" }
const _hoisted_48 = { class: "mt-6 pt-6 border-t border-slate-200" }
const _hoisted_49 = { class: "grid grid-cols-2 md:grid-cols-3 gap-4 text-xs text-slate-600" }
const _hoisted_50 = { class: "font-mono text-slate-800 mt-1 break-all" }
const _hoisted_51 = { class: "text-slate-800 mt-1" }
const _hoisted_52 = { class: "text-slate-800 mt-1" }

import { ref } from 'vue'
import { 
  Calendar, 
  Hash, 
  DollarSign, 
  Activity, 
  Clock, 
  Stethoscope,
  AlertCircle,
  CheckCircle,
  XCircle
} from 'lucide-vue-next'

interface BenefitType {
  id: number
  code: string
  code_description: string
}

interface PracticeType {
  code: string
  code_description: string
}

interface TariffCode {
  id: number
  benefit_type: BenefitType[]
  deleted: string | null
  date_created: string
  date_modified: string
  code: string
  code_description: string
  is_hbc: boolean
}

interface CodeType {
  code: string
  code_description: string
}

interface LimitType extends CodeType {
  id: number
}

interface FrequencyType extends CodeType {
  id: number
}

interface TariffRate {
  rate_id: string
  tariff_code: TariffCode
  practice_type: PracticeType[]
  billing_type: CodeType
  limit_type: LimitType
  frequency: FrequencyType
  deleted: string | null
  date_created: string
  date_modified: string
  applicable_year: number
  applicable_limits: number
  active: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TariffCodeDetailView',
  setup(__props) {

const tariffRates = ref<TariffRate[]>([
  {
    "rate_id": "f823441c-637d-4693-81f7-cea15d97b462",
    "tariff_code": {
      "id": 8,
      "benefit_type": [
        {
          "id": 4,
          "code": "RI",
          "code_description": "Remote Intensive"
        },
        {
          "id": 2,
          "code": "SI",
          "code_description": "Standard Intensive"
        }
      ],
      "deleted": null,
      "date_created": "2023-07-06T10:29:52.948688+02:00",
      "date_modified": "2024-01-29T02:46:36.386209+02:00",
      "code": "PCRT1",
      "code_description": "Palliative Care - Remote transition to Intensive - Remote GP",
      "is_hbc": false
    },
    "practice_type": [
      {
        "code": "006",
        "code_description": "Internal Practices"
      },
      {
        "code": "014",
        "code_description": "GP"
      },
      {
        "code": "015",
        "code_description": "General Practitioner"
      }
    ],
    "billing_type": {
      "code": "FFS",
      "code_description": "Fee for service"
    },
    "limit_type": {
      "id": 1,
      "code": "LT",
      "code_description": "Per Lifetime"
    },
    "frequency": {
      "id": 1,
      "code": "C",
      "code_description": "Per consultation"
    },
    "deleted": null,
    "date_created": "2024-12-15T16:46:26.641540+02:00",
    "date_modified": "2024-12-15T16:46:26.641561+02:00",
    "applicable_year": 2025,
    "applicable_limits": 1,
    "active": false
  },
  {
    "rate_id": "2cb3bdcd-729e-4a8c-8ffd-dfb807b4d97b",
    "tariff_code": {
      "id": 18,
      "benefit_type": [
        {
          "id": 4,
          "code": "RI",
          "code_description": "Remote Intensive"
        },
        {
          "id": 2,
          "code": "SI",
          "code_description": "Standard Intensive"
        }
      ],
      "deleted": null,
      "date_created": "2023-07-06T15:53:39.232670+02:00",
      "date_modified": "2024-01-29T02:36:42.933101+02:00",
      "code": "PCIH88",
      "code_description": "Nurse In Hospital Visit - Remote Intensive Tier 2 - Non-Consortium MDT",
      "is_hbc": false
    },
    "practice_type": [
      {
        "code": "006",
        "code_description": "Internal Practices"
      },
      {
        "code": "050",
        "code_description": "Group Practice"
      },
      {
        "code": "079",
        "code_description": "Hospice"
      },
      {
        "code": "080",
        "code_description": "Nursing Agencies"
      },
      {
        "code": "088",
        "code_description": "Registered Nurse"
      }
    ],
    "billing_type": {
      "code": "FFS",
      "code_description": "Fee for service"
    },
    "limit_type": {
      "id": 1,
      "code": "LT",
      "code_description": "Per Lifetime"
    },
    "frequency": {
      "id": 1,
      "code": "C",
      "code_description": "Per consultation"
    },
    "deleted": null,
    "date_created": "2024-12-15T16:20:54.173791+02:00",
    "date_modified": "2024-12-15T16:20:54.173803+02:00",
    "applicable_year": 2025,
    "applicable_limits": 32,
    "active": false
  }
])

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

const getStatusColor = (active: boolean) => {
  return active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
}

const getStatusIcon = (active: boolean) => {
  return active ? CheckCircle : XCircle
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mb-8" }, [
        _createElementVNode("h1", { class: "text-4xl font-bold text-slate-800 mb-2" }, "Tariff Rates Management"),
        _createElementVNode("p", { class: "text-slate-600" }, "Comprehensive view of healthcare tariff codes and billing information")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tariffRates.value, (rate) => {
          return (_openBlock(), _createElementBlock("div", {
            key: rate.rate_id,
            class: "bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-slate-200"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(Stethoscope), { class: "w-6 h-6" }),
                    _createElementVNode("h2", _hoisted_8, _toDisplayString(rate.tariff_code.code), 1),
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getStatusIcon(rate.active)), { class: "w-5 h-5" }))
                  ]),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(rate.tariff_code.code_description), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([getStatusColor(rate.active), "px-4 py-2 rounded-full font-semibold text-sm"])
                }, _toDisplayString(rate.active ? 'Active' : 'Inactive'), 3)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(Calendar), { class: "w-4 h-4" }),
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-xs opacity-90" }, "Year", -1))
                  ]),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(rate.applicable_year), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(Hash), { class: "w-4 h-4" }),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-xs opacity-90" }, "Limits", -1))
                  ]),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(rate.applicable_limits), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(Activity), { class: "w-4 h-4" }),
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs opacity-90" }, "Practices", -1))
                  ]),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(rate.practice_type.length), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(DollarSign), { class: "w-4 h-4" }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs opacity-90" }, "ID", -1))
                  ]),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(rate.tariff_code.id), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_26, [
                      _createVNode(_unref(Activity), { class: "w-4 h-4 text-[#225f7a]" }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Benefit Types ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rate.tariff_code.benefit_type, (benefit) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: benefit.id,
                          class: "bg-blue-50 text-blue-700 px-3 py-2 rounded-lg text-sm font-medium border border-blue-200"
                        }, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(benefit.code), 1),
                          _createTextVNode(" - " + _toDisplayString(benefit.code_description), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_unref(DollarSign), { class: "w-4 h-4 text-[#225f7a]" }),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-600" }, "Billing Type", -1))
                      ]),
                      _createElementVNode("p", _hoisted_32, _toDisplayString(rate.billing_type.code), 1),
                      _createElementVNode("p", _hoisted_33, _toDisplayString(rate.billing_type.code_description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_unref(Clock), { class: "w-4 h-4 text-[#225f7a]" }),
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-600" }, "Frequency", -1))
                      ]),
                      _createElementVNode("p", _hoisted_36, _toDisplayString(rate.frequency.code), 1),
                      _createElementVNode("p", _hoisted_37, _toDisplayString(rate.frequency.code_description), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_unref(AlertCircle), { class: "w-4 h-4 text-amber-600" }),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-xs font-semibold text-amber-900" }, "Limit Type", -1))
                    ]),
                    _createElementVNode("p", _hoisted_40, _toDisplayString(rate.limit_type.code), 1),
                    _createElementVNode("p", _hoisted_41, _toDisplayString(rate.limit_type.code_description), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_42, [
                    _createVNode(_unref(Stethoscope), { class: "w-4 h-4 text-[#225f7a]" }),
                    _cache[8] || (_cache[8] = _createTextVNode(" Eligible Practice Types ", -1)),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(rate.practice_type.length) + " total ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rate.practice_type, (practice) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: practice.code,
                        class: "bg-gradient-to-r from-slate-50 to-white p-3 rounded-lg border border-slate-200 hover:border-[#225f7a] hover:shadow-md transition-all"
                      }, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, _toDisplayString(practice.code), 1),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(practice.code_description), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-semibold" }, "Rate ID:", -1)),
                    _createElementVNode("p", _hoisted_50, _toDisplayString(rate.rate_id), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-semibold" }, "Created:", -1)),
                    _createElementVNode("p", _hoisted_51, _toDisplayString(formatDate(rate.date_created)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-semibold" }, "Modified:", -1)),
                    _createElementVNode("p", _hoisted_52, _toDisplayString(formatDate(rate.date_modified)), 1)
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})